/**
 * <TutorMonthSummarySkeleton> — la forme de « Mon mois » pendant le premier chargement.
 *
 * Le cas courant : un masteur classé, quatre chiffres (score, rang, heures, euros), puis la ligne de
 * dates et « Détails ». L'intitulé ne dépend d'aucune donnée : il s'écrit, « Détails » aussi.
 */
import React from "react"
import { View } from "react-native"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../../molecules/Card"
import { List } from "../../molecules/List"
import { TUTOR_MONTH_SUMMARY_TITLE, tutorMonthSummaryStyles as styles } from "./TutorMonthSummary"

const TILES = ["score", "rank", "hours", "amount"]

export function TutorMonthSummarySkeleton() {
    return (
        <List title={TUTOR_MONTH_SUMMARY_TITLE}>
            <Card p="4">
                <Stack gap="3">
                    <View style={styles.tiles}>
                        {TILES.map((tile) => (
                            <View key={tile} style={styles.tile}>
                                <Skeleton textSize="text-2xl" width={56} />
                                <Skeleton textSize="text-sm" width={64} />
                            </View>
                        ))}
                    </View>
                    <Row gap="2" justify="between" align="center">
                        <Skeleton textSize="text-xs" width={120} />
                        <Skeleton textSize="text-sm" width={56} />
                    </Row>
                </Stack>
            </Card>
        </List>
    )
}
